const RECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js';

function sleep(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

/**
 * Ensures Google reCAPTCHA script is present and `window.grecaptcha` is available.
 * Returns `true` if ready, otherwise `false` (e.g., blocked by network/adblock).
 */
export async function ensureRecaptchaLoaded(options?: { timeoutMs?: number; pollMs?: number }): Promise<boolean> {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if ((window as any).grecaptcha) return true;

  const timeoutMs = options?.timeoutMs ?? 10_000;
  const pollMs = options?.pollMs ?? 50;

  const existing = document.querySelector(`script[src="${RECAPTCHA_SRC}"]`) as HTMLScriptElement | null;

  if (!existing) {
    const script = document.createElement('script');
    script.src = RECAPTCHA_SRC;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    if ((window as any).grecaptcha) return true;
    await sleep(pollMs);
  }

  return Boolean((window as any).grecaptcha);
}
